import React from 'react';

const SearchAndFilter = ({ onSearch, onSort }) => {
  return (
    <div className="d-flex align-items-center gap-3 mb-3">
      <div className="search-input flex-grow-1">
        <input
          type="text"
          className="form-control"
          placeholder="Search by name, email or phone..."
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <div className="sort-select">
        <select 
          className="form-select" 
          onChange={(e) => onSort(e.target.value)}
        >
          <option value="">Sort by</option>
          <option value="name_asc">Name (A-Z)</option>
          <option value="name_desc">Name (Z-A)</option>
          <option value="username_asc">Username (A-Z)</option>
          <option value="username_desc">Username (Z-A)</option>
          <option value="email_asc">Email (A-Z)</option>
          <option value="email_desc">Email (Z-A)</option>
        </select>
      </div>
    </div>
  );
};

export default SearchAndFilter; 